"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Removes the first element from an array and returns it.
 */
function shift(array) {
    return array.slice(1);
}
exports.shift = shift;
//# sourceMappingURL=shift.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/@immutable-array/shift/lib/shift.js
// module id = 968
// module chunks = 0